import { usePwaUpdates } from "@/application/hooks/pwa/use-pwa-updates";
import { RefreshCw, X } from "lucide-react";
import Button from "../design-system/button/button";

/**
 * Displays a subtle toast-style banner when a new version of the app has
 * been deployed. The user can choose to reload immediately or dismiss.
 *
 * This must be mounted at the root level (inside Providers) so it is available
 * on every page without re-mounting on navigation.
 */
export function PwaUpdateNotification() {
  const { needRefresh, applyUpdate, dismissUpdate } = usePwaUpdates();

  if (!needRefresh) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed bottom-24 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 items-center gap-3 rounded-2xl border border-nt-neutral-200 bg-white px-4 py-3 shadow-lg lg:bottom-6">
      <RefreshCw
        size={18}
        className="shrink-0 text-nt-secondary"
        aria-hidden="true"
      />

      <p className="flex-1 font-poppins text-sm text-nt-neutral-800">
        Nueva versión disponible
      </p>

      <Button
        onClick={applyUpdate}
        className="shrink-0 rounded-xl bg-nt-secondary px-3 py-1.5 font-poppins text-xs font-medium text-white transition-colors duration-200 hover:bg-nt-secondary-600">
        Actualizar
      </Button>

      <Button
        variant={"ghost"}
        size={"icon"}
        onClick={dismissUpdate}
        aria-label="Cerrar"
        className="shrink-0 rounded-lg p-1 text-nt-neutral-500 transition-colors duration-200 hover:bg-nt-neutral-100 hover:text-nt-neutral-800">
        <X size={16} />
      </Button>
    </div>
  );
}
